export function getAll() {
  return [
    {
      value: 0,
      name: "StandardCost",
      text: "標準成本",
    },
    {
      value: 2,
      name: "PreviousCost",
      text: "前次進貨價",
    },
  ];
}

export function getByValue(value) {
  const type = getAll().find(function (item) {
    return item.value == value;
  });
  return type;
}
